export default "__VITE_ASSET__BV8Z9rga__"